import PublicMobileMenu from "./PublicMobileMenu/PublicMobileMenu";
import PublicPcMenu from "./PublicPcMenu/PublicPcMenu";
import NewsAdminContext from "../../context/AdminContext/NewsAdminContext/NewsAdminContext";

const PublicLayout = ({ children }) => {
  return (
    <NewsAdminContext>
      <PublicPcMenu />
      <main>{children}</main>
      <PublicMobileMenu />
    </NewsAdminContext>
  );
};

export default PublicLayout;